import { ADMIN_API } from "./adminApi";
import { ApiOk } from "./adminCommon.types";
import { AdminRole } from "./adminAuth.types";

export type AdminTeamUser = {
  id: number;
  name: string;
  email: string;
  role: AdminRole;
  active: boolean;
  lastLoginAt: string | null;
  createdAt: string;
};

export const listAdminTeam = async () => {
  const { data } = await ADMIN_API.get<ApiOk<AdminTeamUser[]>>("/api/admin/equipe");
  return data.data;
};

export const createAdminTeamUser = async (payload: { name: string; email: string; senha: string; role: AdminRole }) => {
  const { data } = await ADMIN_API.post<ApiOk<AdminTeamUser>>("/api/admin/equipe", payload);
  return data.data;
};

export const updateAdminTeamUser = async (
  id: number,
  payload: Partial<{ name: string; role: AdminRole; active: boolean; senha: string }>
) => {
  const { data } = await ADMIN_API.put<ApiOk<AdminTeamUser>>(`/api/admin/equipe/${id}`, payload);
  return data.data;
};

export const deactivateAdminTeamUser = async (id: number) => {
  await ADMIN_API.delete(`/api/admin/equipe/${id}`);
};
